import { useEffect, useState } from "react";
import newsDatas from "../assets/dummy/DataNews.json";

function PromotionNews({ getData , getLink }) {
  let [newss, setNews] = useState([]);

  useEffect(() => {
    getData(
      "보도 자료",
      "헬리오센의 관련 서비스 및",
      "새로운 소식을 전합니다."
    );
    getLink(window.location.href);
    
  }, [getData, getLink]);

  
  useEffect(() => {
    if(!newsDatas){
      return
    }

    const newsData = newsDatas.News;
    let temp = [];
    for (let i = newsData.length - 1; newsData.length - (newsData.length + 1) < i; i--) {
      temp.push(newsData[i]);
    }
    setNews(temp);
    
  }, []);
  

  const onLink = (url) => {
    window.open(url);
  };

  return (
    <>
      <h2 className="basic-title">새소식</h2>
      <div className="basic-subtitle news-subtitle">
        <p>헬리오센의 새소식을 업데이트 합니다.</p>
      </div>
      <div>
        <ul className="news-item">
          {newss.map((news) => (
            <li
              className="news-list"
              key={news.id}
              onClick={() => onLink(news.url)}
            >              
              <img className="news-img" src={news.img} alt="news" />
              <h3 className="news-title">
                {news.title.split("\n").map((idx) => {
                  return (
                    <span className="txt" key={idx}>
                      {idx}
                    </span>
                  );
                })}
              </h3>
              <div className="news-txt-wrap">
                <p className="news-date">{news.date}</p>
                <p className="news-company">{news.source}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default PromotionNews;
